import AuthReducers from './reducers';

export default AuthReducers;
